// Shared board-basis catalogue. Single source of truth for the four
// public board plans across the site:
//   • Inline board-options dropdowns (RoomRatesStrip, RoomServicePricing)
//   • Homepage HomeBookingWidget per-property blocks
//   • /booking page HotelDetailPanel
//
// Keep the keys stable — they're stored on the per-property detail
// payload and persisted through URL params.

export const BOARD_LABELS = {
  room_only:  { en: "Room only",           fr: "Hébergement seul",         es: "Solo alojamiento" },
  breakfast:  { en: "Breakfast included",  fr: "Petit-déjeuner inclus",    es: "Desayuno incluido" },
  half_board: { en: "Half-board included", fr: "Demi-pension incluse",     es: "Media pensión incluida" },
  full_board: { en: "Full-board included", fr: "Pension complète incluse", es: "Pensión completa incluida" },
};

// Bivouac / desert camp variant — "Tent Only" instead of "Room only" on
// the room-only tier. All meal-included tiers keep the shared wording.
export const BOARD_LABELS_BIVOUAC = {
  ...BOARD_LABELS,
  room_only:  { en: "Tent only",           fr: "Tente seule",              es: "Solo tienda" },
};

export const BOARD_ORDER = ["room_only", "breakfast", "half_board", "full_board"];

export const BOARD_FIELD_LABEL = {
  en: "Board basis", fr: "Formule de pension", es: "Régimen de pensión",
};

export const pickBoardLabel = (key, lang, { bivouac = false } = {}) => {
  const bag = bivouac ? BOARD_LABELS_BIVOUAC : BOARD_LABELS;
  const entry = bag[key];
  if (!entry) return "";
  return entry[lang] || entry.en || "";
};
